<template>
  <div id="ShareQrCodeModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="p-5">{{ 'Download the file to your phone using this QR-Code' | trans }}</div>
        <div class="w-100 d-flex justify-content-center pb-5">
          <div class="qr-code"></div>
        </div>
        <div class="modal-footer">
          <button class="btn close-btn" @click.prevent="close">
            <i class="fa fa-times mr-1"></i><strong>{{ 'Cancel' | trans }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import {EventBus} from '../../events/event.bus';
import user from "../../mixins/user.mixin";
import currentJob from "../../mixins/current_job.mixin";
import JobManager from "../../manager/JobManager";
import {EVENT_QR_SHARE} from "../../events/app.events";
import 'jquery.qrcode';
import Analytics from "../../util/Analytics";

export default {
  name: 'ShareQrCodeModal',
  props: {},
  components: {},
  mixins: [store, user, currentJob],
  data() {
    return {
      content_type: 'none'
    };
  },
  mounted: function () {
    $('#ShareQrCodeModal').modal({show: false});
    $('.qr-code').qrcode( window.location.href + '&qr=true');
  },
  created: function () {
    EventBus.$on(EVENT_QR_SHARE, (data) => {
      Analytics.send('result_action', 'open_qr_share', this.currentJob);

      $('#ShareQrCodeModal').modal('show');
    });
  },
  methods: {
    close() {
      $('#ShareQrCodeModal').modal('hide');
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
#ShareQrCodeModal {
  img {
    width: 100%;
    height: auto;
  }

  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .premium-btn {
    background-color: #ffaa00;
    height: 38px;
    gap: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    padding: 0 10px 0 10px;
  }

  .modal-content-title {
    font-size: 28px;
    font-weight: 600;
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }
}
</style>
